import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { LockIcon } from 'lucide-react';
interface IPCOfficerProps {
  onNavigate?: (page: string) => void;
}
export function IPCOfficer({
  onNavigate
}: IPCOfficerProps) {
  const {
    colors
  } = useTheme();
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Check if access code is correct (demo: "1234")
    if (accessCode === '1234') {
      setError('');
      if (onNavigate) {
        onNavigate('ipc-dashboard');
      }
    } else {
      setError('Invalid access code. Please try again.');
    }
  };
  return <div className="space-y-6 max-w-md mx-auto" data-id="element-239">
      <div className="p-8 rounded-xl flex flex-col items-center justify-center text-center" style={{
      backgroundColor: colors.cardSurface
    }} data-id="element-240">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mb-6" style={{
        backgroundColor: colors.warning + '20'
      }} data-id="element-241">
          <LockIcon size={32} style={{
          color: colors.warning
        }} data-id="element-242" />
        </div>
        <h2 className="text-2xl font-bold mb-2" style={{
        color: colors.textPrimary
      }} data-id="element-243">
          Restricted Area
        </h2>
        <p className="mb-6" style={{
        color: colors.textSecondary
      }} data-id="element-244">
          This section is only available to users with IPC Officer privileges.
          Please enter your access code to continue.
        </p>
        <form onSubmit={handleSubmit} className="w-full space-y-4" data-id="element-245">
          <div data-id="element-246">
            <label className="block text-sm font-medium mb-2 text-left" style={{
            color: colors.textPrimary
          }} data-id="element-247">
              Access Code
            </label>
            <input type="password" value={accessCode} onChange={e => {
            setAccessCode(e.target.value);
            setError('');
          }} className="w-full p-4 rounded-lg text-center text-lg tracking-widest" style={{
            backgroundColor: colors.background,
            color: colors.textPrimary,
            border: `1px solid ${error ? colors.error : colors.divider}`
          }} placeholder="Enter code" maxLength={6} data-id="element-248" />
            {error && <p className="text-sm mt-2 text-left" style={{
            color: colors.error
          }} data-id="element-249">
                {error}
              </p>}
          </div>
          <button type="submit" className="w-full p-4 rounded-lg font-semibold" style={{
          backgroundColor: colors.accent,
          color: '#FFFFFF'
        }} data-id="element-250">
            Access Dashboard
          </button>
        </form>
        <p className="text-xs mt-4" style={{
        color: colors.textSecondary
      }} data-id="element-251">
          Demo code: 1234
        </p>
      </div>
    </div>;
}